<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-grid"/> {{ caption }}
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="items"
        :items-per-page="itemsPerPage"
        :dark="dark"
        pagination
      >
        <template #role="{ item }">
          <td>
            {{ item.role}}
          </td>
        </template>
        <template #anzahlBenutzer="{ item }">
          <td>
            <CBadge color="info" :href="'/dashboard/users/roles/' + item.role">
             {{ item.anzahlBenutzer }}
            </CBadge>
          </td>
        </template>
        <template #aktiv="{ item }">
          <td>
            <CSwitch
                    class="mx-1"
                    color="success"
                    variant="3d"
                    :checked.sync="item.aktiv"
                    @update:checked="(val) => updateStatus(item.id, val)"
                    shape="pill" />
          </td>
        </template>
        <template #aktionen="{ item }">
          <td>
            <router-link :to="{ path: '/dashboard/users/customer/' + item.id }">
              <CButton color="info">Bearbeiten</CButton>
            </router-link>
            <CButton color="danger" @click="deleteUser(item.id)" class="ml-2">Löschen</CButton>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
  </CCard>
</template>

<script>

  import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Table',
  props: {
    items: Array,
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    itemsPerPage: Number
  },

  methods: {
    ...mapActions('user', ['setAktiv', 'doDelete']),
    updateStatus(id, event) {
      this.setAktiv({id, event})
    },

    deleteUser(id) {
      this.doDelete(id).then(res => {
          if(this.getDeleteStatus === true) {
            this.getShops.splice(this.getShops,id)
          }
      })
    }
  },

  computed: {
    ...mapGetters('shop',['getDeleteStatus', 'getShops'])
  }
}
</script>
